import React, {
  Fragment as _,
  createContext,
  useState,
  useRef,
  useContext,
  useEffect,
  useMemo,
} from 'react';
import { Box } from 'theme-ui';
import { AssessmentContext } from 'components/Module/AssessmentContainer';
import { interactionContext as InteractionContext } from './interactionContext';
import { updateAssessmentAction } from 'actions/updateAssessmentAction';
import { useSelector, useDispatch } from 'react-redux';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import findByKeyVal, { findByKeyVal_V2 } from 'services/findByKeyVal';
import { Block } from '@chameleoncreator/creator-app';
import getBlockById from 'services/apiHelpers/getBlockById';
import { State } from 'store/store';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import SubmitContinue from './SubmitContinue';
import { updateScoreAction } from 'actions/updateScoreAction';
import { addScormResponseAction } from 'actions/addScormResponseAction';
import { AssessmentData } from 'store/store';
import { Report } from 'store/store';

interface IAssessmentQuestionContext {
  singleSelect: boolean;
  selected: string[];
  isLocked: boolean;
}

const AssessmentQuestionContext = createContext<IAssessmentQuestionContext>({
  singleSelect: true,
  selected: [],
  isLocked: false,
});

const CONTINUE = 'Continue';
const SUBMIT = 'Submit';

const hasUpdatedScoreRaw: any = {};

const AssessmentQuestion = ({ children, ...props }) => {
  const assessmentContext = useContext(AssessmentContext);
  const interactionContext = useContext<any>(InteractionContext);

  const { assessmentId, maxAttempts } = assessmentContext;
  // console.log(maxAttempts);

  const { scoring } = getBlockById(assessmentId).props as any;
  // console.log({ scoring });

  const {
    name,
    includeMedia = true,
    dividerColor = '#CADCF2',
    questionCounterColor = 'inherit',
    font = 'inherit',
    textColor,
    correctOptions,
    //
  } = interactionContext.props;

  const { id } = props;

  // questionCounter,
  const [img, text, options, submitBtn] = children;

  // set the default correctOptions to the first option
  if (!correctOptions.length) {
    // correctOptions = [options.props.children[0].props.id];
  }

  const assessment = useSelector((state: State) => {
    // since now we're destroying the assessment in preview on reload
    return state.assessments[assessmentId] || {};
  });

  const assessmentData = assessment && assessment.data ? assessment.data : {};
  const questionData =
    assessment && assessment.results && assessment.results[id]
      ? assessment.results[id]
      : {};

  const {
    answer = [],
    isCorrect = undefined,
    attemptCount = 0,
    submitButtonLabel = 'Submit',
    navigateToResults = false,
    isLocked = false,
  } = questionData;

  const selected = answer;
  const setSelected = selected => {
    dispatch(
      updateAssessmentAction({
        assessmentId,
        questionData: {
          [id]: {
            ...questionData,
            answer: selected,
          },
        },
      })
    );
  };

  const dispatch = useDispatch();
  //

  const interactionsInAssessment = getInteractionsInTopic(
    getBlockById(assessmentId)
  );

  const questions = interactionsInAssessment.filter((i: any) => {
    return [i.props.type, i.meta.subType].includes('AssessmentQuestion');
  });

  const questionIndex = questions.findIndex((q: any) => {
    //
    return q.children[0].id === id;
  });

  const singleSelect = correctOptions.length === 1;

  if (window.dev && window.dev()) {
    // isLocked = false;
  }

  const location = useMemo(() => {
    const assessment = getCurrentTopic() as Block;
    const resultsPage =
      interactionsInAssessment[interactionsInAssessment.length - 1];
    return `${assessment?.props?.sId || assessment.id}/${resultsPage?.props
      ?.sId || resultsPage.id}`;
  }, []);
  //

  const onSubmit = () => {
    if (submitButtonLabel === 'Continue') {
      return;
    }

    //
    const isCorrect = selected.sort().join() === correctOptions.sort().join();

    dispatch(
      updateAssessmentAction({
        assessmentId,
        questionData: {
          [id]: {
            id,
            questionName: name,
            answer: selected,
            correctAnswer: correctOptions,
            isCorrect,
            attemptCount: attemptCount ? attemptCount + 1 : 1,
            submitButtonLabel: 'Continue',
            navigateToResults: false,
            isLocked: true,
          },
        },
      })
    );

    let questionText: HTMLDivElement | string = document.querySelector(
      `#i${interactionContext.id} form .chameleon-text`
    ) as HTMLDivElement;

    if (questionText) {
      questionText = questionText.innerText;
    }

    //

    const optionIds = options.props.children.map((o: any) => {
      return o.props.id;
    });

    const response = selected
      .map(s => {
        return `${optionIds.indexOf(s) + 1}`;
      })
      .sort()
      .join(',');

    const getCorrectAndResponseOptions = entry => {
      let answer = '';

      const content = document.querySelector(`#i${entry}`) as HTMLInputElement;
      if (content && content.labels) {
        answer = content.labels[0].innerText;
      }

      // console.log(answer);

      return answer;
    };

    const correctExpanded = correctOptions
      .map(getCorrectAndResponseOptions)
      .join(',');

    const responseExpanded = selected
      .map(getCorrectAndResponseOptions)
      .join(',');

    // console.log(questionText);
    // console.log('correct :', correctExpanded);
    // console.log('response :', responseExpanded);

    // this mimics the multichoice / sortation pattern of updating userBehaviour
    //
    const action = {
      id,
      type: 'fill-in',
      question: questionText,
      reportable: 'multichoice' as 'multichoice',
      response: responseExpanded,
      correct: correctExpanded,
      result: !isCorrect ? 0 : 1,
    } as Report;

    if (scoring) {
      dispatch(updateScoreAction(interactionContext.id, !isCorrect ? 0 : 1));
      dispatch(addScormResponseAction(action));
    }
  };

  useEffect(() => {
    if (!scoring || hasUpdatedScoreRaw[interactionContext.id]) {
      return;
    }

    //
    if (isLocked && isCorrect && !hasUpdatedScoreRaw[interactionContext.id]) {
      dispatch(updateScoreAction(interactionContext.id, 1));
      hasUpdatedScoreRaw[interactionContext.id] = true;

      // console.log('send scoreRaw on load. . .', {
      //   isLocked,
      //   isCorrect,
      //   [interactionContext.id]: hasUpdatedScoreRaw[interactionContext.id],
      // });
    }
  }, [isLocked, isCorrect]);

  // useEffect(() => {
  //   const onKeyDownWindow = e => {
  //     if (e.keyCode === 32 && e.target === document.body) {
  //       console.log(e.target);
  //       e.preventDefault();
  //     }
  //   };

  //   window.addEventListener('keydown', onKeyDownWindow);

  //   return () => {
  //     window.removeEventListener('keydown', onKeyDownWindow);
  //   };
  // };

  return (
    <AssessmentQuestionContext.Provider
      value={
        {
          singleSelect,
          selected: window.dev && window.dev() ? correctOptions : selected,
          setSelected(id) {
            if (singleSelect) {
              setSelected([id]);

              return;
            }

            const newSelected: string[] = [...selected];

            if (!newSelected.includes(id)) {
              newSelected.push(id);
              setSelected(newSelected);
              return;
            }

            newSelected.splice(newSelected.indexOf(id), 1);
            setSelected(newSelected);
          },
          isLocked,
        } as IAssessmentQuestionContext
      }
    >
      <form
        style={{
          width: '100%',
          height: '100%',
        }}
        onSubmit={e => {
          e.preventDefault();
        }}
      >
        <Box
          sx={{
            // margin: '50px 0',
            padding: '50px 20px',
            // this'll lock the question
            ...(isLocked && {
              '*': {
                // pointerEvents: 'none',
                // opacity: 0.5,
              },
            }),
          }}
        >
          <Box
            as="h4"
            sx={{
              margin: includeMedia ? 0 : '20px 0',
              fontSize: '16px',
              color: questionCounterColor || textColor,
              textAlign: 'center',
              fontFamily: `${font} !important`,

              '*': {
                fontFamily: `${font} !important`,
              },
            }}
          >
            Question {questionIndex + 1} of {questions.length}
          </Box>
          {includeMedia && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                margin: '20px 0',
                img: {
                  // maxWidth: 'calc(30vh) !important',
                },
              }}
            >
              {img}
            </Box>
          )}

          <Box sx={{}}>{text}</Box>

          <Box
            as="hr"
            sx={{
              margin: '30px 0 25px 0',
              border: `1px solid ${dividerColor || '#CADCF2'}`,
            }}
            aria-hidden="true"
          />
          <Box
            sx={{
              ...(isLocked && {
                pointerEvents: 'none',
              }),
            }}
          >
            {options}
          </Box>

          <SubmitContinue
            selected={selected}
            location={location}
            onSubmit={onSubmit}
            navigateToResults={navigateToResults}
          >
            {React.cloneElement(submitBtn, {
              label: submitButtonLabel,
            })}
          </SubmitContinue>
        </Box>
      </form>
    </AssessmentQuestionContext.Provider>
  );
};

export default AssessmentQuestion;
export { AssessmentQuestionContext };
